import React, { Fragment, useEffect, useState } from 'react';

import Block from '../../../Scafolding/Block';
import { TextHeader, TextTitle } from '../../../Digital/TextHeaders';

import { Container, Row, Col, Table, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { SSDComps } from '../../../../Brands/SSD/Start'; 
import { ComingSoon } from '../../../../Brands/ComingSoon'; 

export const Comps_NationalResults = (props) => {
    return (
        <SSDComps>
            <Comps_NationalResultsContent />
        </SSDComps>
    );
}   
export default Comps_NationalResults;

export const Comps_NationalResultsContent = (props) => {

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
    }, []);

    return (
        <Block name="NationalRecords" isAlt={false}>

            <TextHeader
                text="National Records"
            />

            <TextTitle
                text="All the National Official Australian Records from the USFA & AUF..."
            />

            <TextTitle
                text="Cooming Soon..."
            />

        </Block>
    );
}
